require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-vittorio-pedrocchi.json") })
        }
      }, "path---en-interviste-vittorio-pedrocchi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-vittorio-pedrocchi!./.cache/json/en-interviste-vittorio-pedrocchi.json
// module id = 600
// module chunks = 231608221292675